export function isBrowser() {
  return typeof window !== "undefined";
}

const is_browser = isBrowser();
export function isDeployed() {
  return is_browser ? window.location.hostname !== "localhost" : import.meta.env.PUBLIC_IAI_DEPLOYED === "true";
}
